import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager", webpackExports: ["AllProviders"] */ "/opt/build/repo/src/app/provider/AllProviders.tsx");
